import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import swal from 'sweetalert';
import {Table, Button} from 'react-bootstrap';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {pencil} from 'react-icons-kit/icomoon/pencil';
import {bin} from 'react-icons-kit/icomoon/bin';
import {print} from 'react-icons-kit/fa/print';
import Help from '../../generics/help';

const Config = require('../../../config');

class Campaign extends Component{
	constructor(props){
		super(props);

		this.newCampaign = this.newCampaign.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getList = this.getList.bind(this);
		this.onDelete = this.onDelete.bind(this);
		this.onEdit = this.onEdit.bind(this);

		this.state = {
			filterText:"",
			listado:[],
		}
	}

	componentDidMount(){
		this.getList();	

	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'campaigns',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({listado:response});
			}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	newCampaign(e){
		e.preventDefault();

		this.props.history.push('/promotion/campaign/new');
	}

	onDelete(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm) => {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'campaigns/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    });
	}

	onEdit(id){
		this.props.history.push('/promotion/campaign/edit/'+id);
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.name !== null &&
				row.convoke_places_name !== null
			){
				if(
					row.name.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.convoke_places_name.indexOf(this.state.filterText.toUpperCase()) !== -1 					
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	async onPrint(id){

		this.props.waiting.handleShow('Imprimiendo...');
				
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = 'AREA_PROMOTION';
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
		}else{
			this.props.waiting.handleClose();
		}
	
		
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					Promoción ->
					Listado
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_promotion"} 
	                submenu={"help_campaigns"}  />
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-9">
							<button type="button" className="btn btn-info" onClick={this.newCampaign} 
								style={{float:"right", fontSize:"14px"}}
								disabled={!this.props.task_promotion_campaign.create}>
								Nuevo
							</button>
						</div>
					</div>

					<div className="col-xs-12 form-group">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Campaña</th>
									<th>Lugar de Colecta</th>
									<th>Fecha de inicio</th>
									<th>Fecha de termino</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.state.listado.map((list, i)=>(
									this.filter(list) ? 
										<tr key={i}>
											<td>{list.name}</td>
											<td>{list.convoke_places_name}</td>
											<td>{moment(list.start_date).format('DD/MM/YYYY')}</td>
											<td>{moment(list.end_date).format('DD/MM/YYYY')}</td>
											<td>
												<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:"5px"}}
													onClick={(e)=>this.onPrint(list.id)} >
													<SvgIcon icon={print} />
												</Button>
												<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
													onClick={this.onEdit.bind(this, list.id)}
													disabled={!this.props.task_promotion_campaign.update} >
													<SvgIcon icon={pencil}/>
												</Button>
												<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:"5px"}}
													onClick={(e)=>this.onDelete(list.id)}
													disabled={!this.props.task_promotion_campaign.delete} >
													<SvgIcon icon={bin} />
												</Button>
											</td>
										</tr>
									:null
								))}
							</tbody>
						</Table>
					</div>
				</form>
			</div>
		)
	}
}

export default translate('translations')(Campaign);